import { VisitRequestWorkflowStep, VisitWorkflowStep } from '@/types/graphql';
import _ from 'lodash';

import {
    VisitState,
    workflowStepFromVisitRequestWorkflowStep,
    workflowStepToInt,
} from '../../types/visit';

export const getWorkflowStepCounts = ({
    occurrences,
}: {
    occurrences: { workflowStep?: VisitRequestWorkflowStep | VisitWorkflowStep }[];
}) => {
    return _.countBy(occurrences, 'workflowStep');
};

export const getNextWorkflowStep = ({
    occurrences,
}: {
    occurrences: { workflowStep?: VisitRequestWorkflowStep }[];
}) => {
    const workflowStepCounts = getWorkflowStepCounts({ occurrences });
    const nextStep = Object.values(VisitRequestWorkflowStep).find(
        (workflowStep) => workflowStepCounts[workflowStep] > 0,
    );
    return nextStep;
};

export function getUnifiedStateIndex({
    workflowStep,
    visitState,
}: {
    workflowStep?: VisitRequestWorkflowStep | VisitWorkflowStep;
    visitState?: VisitState;
}) {
    let visitWorkflowStep;
    // TODO(jessica): Deprecate support for visit request workflow steps.
    if (
        workflowStep &&
        Object.values(VisitRequestWorkflowStep).includes(workflowStep as VisitRequestWorkflowStep)
    ) {
        visitWorkflowStep = workflowStepFromVisitRequestWorkflowStep(
            workflowStep as VisitRequestWorkflowStep,
        );
    }
    if (visitWorkflowStep) {
        return workflowStepToInt(visitWorkflowStep);
    }
    if (visitState) {
        return (
            Object.values(VisitState).indexOf(visitState) + Object.values(VisitWorkflowStep).length
        );
    }
    return 0;
}
